import React from "react";
import { Card, CardContent } from "@/components/ui/card";

const MissionSection = () => {
  return (
    <div id="mission" className="space-y-12">
      <div className="space-y-6">
        <h2 className="text-3xl font-bold font-mono">Our Mission</h2>
        <Card className="bg-secondary/50 dark:bg-secondary/20 border-secondary/70">
          <CardContent className="pt-6">
            <p className="text-lg mb-6">
              OpenPipe helps enterprises turn ambitious AI ideas into
              production‑grade reality. We specialize in reinforcement learning
              (RL) and custom fine‑tuning that align powerful models with each
              customer's unique goals, security posture, and infrastructure.
            </p>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold mb-2">Who We Are</h3>
                <p className="text-muted-foreground">
                  We're a team of serial entrepreneurs and industry veterans who
                  have built and scaled AI systems at the world's most demanding
                  companies. Backed by Y Combinator and leading venture
                  partners, we combine deep research expertise with a bias for
                  real‑world impact.
                </p>
              </div>
              <div className="space-y-6">
                <h4 className="text-lg font-semibold mb-2">Founders</h4>
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-background/80 dark:bg-background/20 p-4 rounded-lg">
                    <h4 className="font-semibold mb-2">Kyle Corbitt, CEO</h4>
                    <p className="text-sm text-muted-foreground">
                      Serial entrepreneur and former Product Director at YC,
                      Google, and Facebook. Kyle has led large‑scale AI training
                      and inference programs and now guides OpenPipe's vision
                      and product strategy.
                    </p>
                  </div>
                  <div className="bg-background/80 dark:bg-background/20 p-4 rounded-lg">
                    <h4 className="font-semibold mb-2">David Corbitt, CPO</h4>
                    <p className="text-sm text-muted-foreground">
                      Alumnus of Palantir and Qualtrics, David leads product at
                      OpenPipe. He immensely enjoys helping builders overcome
                      roadblocks and building out new ideas for LLM apps.
                    </p>
                  </div>
                </div>
                <div className="bg-background/80 dark:bg-background/20 p-4 rounded-lg mt-4">
                  <h4 className="font-semibold mb-2">
                    Additional Engineering & Research Team
                  </h4>
                  <p className="text-sm text-muted-foreground">
                    Alumni of Anthropic, Microsoft, Amazon, Facebook, Google,
                    Palantir, Qualtrics, Goldman Sachs, Oracle, and more.
                    Collectively, our staff has authored multiple high‑impact
                    publications on GRPO, RLHF, and fine‑tuning techniques that
                    achieve state‑of‑the‑art performance on custom enterprise
                    tasks.
                  </p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default MissionSection;
